module.exports = "/virtual-football-league/img/amblems/right/logos/Watford.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Watford.png
// module id = 2235
// module chunks = 4